import React, { useState } from 'react';
import styles from '../stateroomdetails.module.scss';
import { InsuranceDetailsProps } from '@msc-b2c/interfaces/types';
import { Accordion } from '@msc-b2c/shared-components';
import PassengersInfo from './PassengersInfo';

const Insurance: React.FC<InsuranceDetailsProps> = ({
  insuranceInfo,
  viewDetailsInsuranceLabel,
  openViewDetailsInsuranceIcon,
  closeViewDetailsInsuranceIcon,
}) => {
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <Accordion
      question={insuranceInfo.description}
      answer=""
      isOpen={openId === insuranceInfo.code}
      autoClose={false}
      openingIcon={openViewDetailsInsuranceIcon}
      closingIcon={closeViewDetailsInsuranceIcon}
      multi={true}
      onToggle={() =>
        setOpenId((prev) => (prev === insuranceInfo.code ? null : insuranceInfo.code))
      }
      viewDetailsLabel={viewDetailsInsuranceLabel}
      questionIcon={insuranceInfo.icon}
      styleOption={styles.includedWithBookingAccordion}
    >
      <>
        {insuranceInfo.passengers.map((p, index) => {
          return (
            <div
              key={`insurance-${p.id}-${index}`}
              className={styles.passengerDetailsContainer}
            >
              <div className={styles.passengerDetailsContent}>
                <PassengersInfo
                  key={p.id}
                  passengerLabel={p.passengerLabel ?? ''}
                  passengerName={p.descriptionText ?? ''}
                />
              </div>
            </div>
          );
        })}
      </>
    </Accordion>
  );
};

export default Insurance;
